import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import axios from 'axios'

const Form = styled.form`
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  margin: 10px 0 auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  input,
  textarea {
    letter-spacing: 1px;
    font-family: inherit;
    font-size: inherit;
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.text};
    padding: 1.3rem 1.9rem;
    margin-bottom: 24px;
    &::-webkit-input-placeholder {
      color: gray;
    }
    &::-moz-placeholder {
      color: gray;
    }
    &:-ms-input-placeholder {
      color: gray;
    }
    &:-moz-placeholder {
      color: gray;
    }
    &:required {
      box-shadow: none;
    }
    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      padding: 1rem 1.9rem;
    }
  }
  &::before {
    content: '';
    background: black;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    transition: 0.2s all;
    opacity: ${props => (props.overlay ? '.8' : '0')};
    visibility: ${props => (props.overlay ? 'visible' : 'hidden')};
  }
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    margin: 32px 0 0;
    max-width: 100%;
  }
`

const Name = styled.input`
  margin: 0 0 1em 0;
  border-radius: 30px;
  width: 100%;
`

const Email = styled.input`
  margin: 0 0 1em 0;
  border-radius: 30px;
  width: 100%;
`

const Message = styled.textarea`
  width: 100%;
  border-radius: 10px;
  margin: 0 0 1em 0;
  line-height: 1.6;
  min-height: 115px;
  resize: vertical;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    margin: 1.3rem 0 0;
  }
`

const Submit = styled.input`
  border-radius: 22px;
  background: ${props => props.theme.colors.secondary} !important;
  color: white !important;
  cursor: pointer;
  margin-top: 10px;
  max-width: 144px;
  padding: 0.8rem !important;
  width: 100%;
  transition: 0.2s;
  &:hover {
    background: ${props => props.theme.colors.secondary} !important;
  }
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    max-width: 184px;
    margin: 40px 0 0 !important;
  }
`

const Modal = styled.div`
  background: white;
  padding: 2em;
  border-radius: 2px;
  position: fixed;
  min-width: 75%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  z-index: 99;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  transition: 0.2s all;
  opacity: ${props => (props.visible ? '1' : '0')};
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    min-width: inherit;
    max-width: 400px;
  }
  p {
    line-height: 1.6;
    margin: 0 0 2em 0;
  }
`

const Button = styled.div`
  background: ${props => props.theme.colors.secondary};
  font-size: 1em;
  display: inline-block;
  margin: 0 auto;
  border: none;
  outline: none;
  cursor: pointer;
  color: white;
  padding: 1em;
  border-radius: 22px;
  text-decoration: none;
  transition: 0.2s;
  z-index: 99;
  &:focus {
    outline: none;
  }
  &:hover {
    background: ${props => props.theme.colors.secondary};
  }
`

class ContactForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      email: '',
      message: '',
      showModal: false,
    }
  }

  handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value,
    })
  }

  handleSubmit = event => {
    axios({
      method: 'POST',
      url: 'https://formspree.io/f/mpzokked',
      data: this.state,
    })
      .then(this.handleSuccess)
      .catch(error => alert(error))
    event.preventDefault()
  }

  handleSuccess = () => {
    this.setState({
      name: '',
      email: '',
      message: '',
      showModal: true,
    })
  }

  closeModal = () => {
    this.setState({ showModal: false })
  }

  render() {
    return (
      <Form
        name="contact"
        onSubmit={this.handleSubmit}
        data-netlify="true"
        data-netlify-honeypot="bot"
        overlay={this.state.showModal}
        onClick={this.closeModal}
      >
        <input type="hidden" name="form-name" value="contact" />
        <p hidden>
          <label>
            Don’t fill this out:{' '}
            <input name="bot" onChange={this.handleInputChange} />
          </label>
        </p>

        <Name
          name="name"
          type="text"
          placeholder="Nombre"
          value={this.state.name}
          onChange={this.handleInputChange}
          required
        />
        <Email
          name="email"
          type="email"
          placeholder="Email"
          value={this.state.email}
          onChange={this.handleInputChange}
          required
        />
        <Message
          name="message"
          type="text"
          placeholder="Mensaje"
          value={this.state.message}
          onChange={this.handleInputChange}
          required
        />
        <Submit name="submit" type="submit" value="Enviar" />

        <Modal visible={this.state.showModal}>
          <p>
            Gracias por contactarme. Tratare de responderte lo antes posible.
          </p>
          <Button onClick={this.closeModal}>Okay</Button>
        </Modal>
      </Form>
    )
  }
}

ContactForm.propTypes = {
  data: PropTypes.object,
}

export default ContactForm
